module.exports = __webpack_public_path__ + "assets/img/06-s.74ceaff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/06-s.jpg
// module id = 8S2b
// module chunks = 0